import { $ } from "../../../helpers/dom-selectors.js";
export default function makeProgressComponents({ wrappers }) {
    let initialized = false;
    const PROGRESS_COMPONENTS = [];
    return Object.freeze({
        init,
        showProgress,
        update,
        add,
        reset,
        remove
    });
    function _findByIndex(index) {
        return PROGRESS_COMPONENTS.find(prog => prog.id === index);
    }
    function init() {
        if (initialized)
            return;
        for (let i = 0; i < wrappers.length; i++) {
            PROGRESS_COMPONENTS.push(_newProgress(wrappers[i], i));
        }
        initialized = true;
    }
    // ---------- ADD NEW PROGRESS
    function _newProgress(wrapper, i) {
        return {
            id: i,
            formId: wrapper.getAttribute('data-id'),
            wrapper,
            fileName: $(wrapper, '.progress-file-name')[0],
            progressBar: $(wrapper, '.progress-bar')[0],
            percText: $(wrapper, '.progress-perc')[0]
        };
    }
    function add(id) {
        const wrappers = $(document, '.progress-wrapper');
        const newProgress = _newProgress(wrappers[wrappers.length - 1], id);
        newProgress.formId = null;
        newProgress.wrapper.removeAttribute('data-id');
        PROGRESS_COMPONENTS.push(newProgress);
        reset(id);
    }
    function reset(index) {
        const prog = _findByIndex(index);
        if (!prog)
            return;
        prog.wrapper.classList.add('no-display');
        prog.fileName.innerText = '';
        prog.percText.innerText = '';
        prog.progressBar.style.width = `0%`;
    }
    // ---------- SHOW/UPDATE PROGRESS
    function showProgress(index, fileName) {
        const prog = _findByIndex(index);
        if (!prog)
            return;
        prog.wrapper.classList.remove('no-display');
        prog.fileName.innerText = fileName;
    }
    function update(index, perc) {
        const prog = _findByIndex(index);
        if (!prog)
            return;
        prog.progressBar.style.width = `${perc}%`;
        prog.percText.innerText = `${perc}%`;
    }
    // ---------- REMOVE
    function remove(id) {
        const progIndex = PROGRESS_COMPONENTS.findIndex(prog => prog.formId === id);
        if (progIndex === -1)
            return;
        PROGRESS_COMPONENTS.splice(progIndex, 1);
    }
}
